<script>
import Addresses from "@/components/_Shared/Addresses/Index";

export default {
  components: {
    Addresses
  },

  props: {
    accountable: {
      type: Object,
      required: true
    }
  }
};
</script>

<template>
  <v-card class="mb-20 px-4" flat>
    <v-divider></v-divider>
    <v-row class="my-4 px-4">
      <v-icon color="black" size="25" class="mr-2">house</v-icon>
      <h3 class="font-weight-regular text-uppercase">ENDEREÇOS</h3>
    </v-row>
    <addresses :accountable="accountable" />
  </v-card>
</template>

<style scoped>
@media (max-width: 480px) {
  span {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Customers/Components/Addresses.vue